import {
  SEND_PROFILE_DATA,
  SEND_PROFILE_DATA_SUCCESS,
  SEND_PROFILE_DATA_FAILURE,
} from "../actionTypes";

export const sendProfiledata = (payload) => ({
  type: SEND_PROFILE_DATA,
  payload,
});

export const sendProfiledataSuccess = (payload) => ({
  type: SEND_PROFILE_DATA_SUCCESS,
  payload,
});

export const sendProfiledataFailure = () => ({
  type: SEND_PROFILE_DATA_FAILURE,
});
